<template>
    <div class="comment">
        <div class="comment__top">
            <div class="comment__name">
                {{ data.name }}
            </div>
            <div class="comment__date">
                {{ data.date }}
            </div>
        </div>
        <div class="comment__comment">
            {{ data.comment }}
        </div>
    </div>
</template>

<script>

/* ----------------------------------------
    Component
---------------------------------------- */

export default {

name: 'Comment',

props: ['data'],

data() {
    return {
    };
},

computed: {
},

components: {
},

methods: {
   
},

mounted() {
},

created() {
}

};
</script>
